import React, { Component } from 'react'
import { Col, Row, FormGroup } from "react-bootstrap"
import {  Field, reduxForm, propTypes,formValueSelector,getFormSyncErrors,change   } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { saveSeasonTemplate,resetTemplateSettings } from "../../../redux/actions/action_seasonsettings"
import { lblattrs11 } from '../../../utils/style'
import { onlypositivenumbers } from '../../../utils/helperfunctions/onlypositivenumbers'
import { defaultformstate } from '../../../utils/statedefaultvalues/formstate'
import SeasonHeader from './SeasonHeader'
import ErrorList from './ErrorList'
import InfoSaved from './InfoSaved'

const formName    = 'seasontemplate'
const templateTab = 5

class Template extends Component {
    static propTypes = {
        ...propTypes
    }
    constructor(props,context) {
        super(props,context)
        this.handleSaveTemplate = this.handleSaveTemplate.bind(this) 
        this.handleValueChange  = this.handleValueChange.bind(this)
    }
    componentDidUpdate(){
        const {  initialize,datasaved,settingsSaved,resetform,templatereset,resetDone,dispatch } = this.props
        if (datasaved) {
            initialize({}, true)
            settingsSaved(true,templateTab)
        }
        if(resetform == true){
            resetTemplateSettings()
        }
        if(templatereset == true){
            dispatch(change(formName,'templatereset',false))
            resetDone()
        }
    }
    handleSaveTemplate() {
        const { saveSeasonTemplate, template, settingsseason, dispatch } = this.props
        const season = template[settingsseason]
        const seasontemplate = {
            templateReleaseDays:season.templateReleaseDays,
            seasonId:settingsseason
        }
        dispatch(change(formName, 'savingdata',true))
        saveSeasonTemplate(settingsseason,seasontemplate)
    }
    handleValueChange(){
        const { dispatch, settingsSaved } = this.props 
        dispatch(change(formName,'datasaved',false))
        settingsSaved(true,templateTab)
    }
    render()    {
        const { template, settingsseason,savingdata,datasaved,seasonyears, syncErrors } = this.props
        const season  = `template[${settingsseason}]`
        const errors =  Object.values(syncErrors)

        let isSeasonSet = true
        if(template){
            isSeasonSet = template[settingsseason].isSeasonSet
        }
        return (
            <Row className="center-block center-text">
                <form className="form-horizontal" sm={6}  style={{ padding:'0',margin:'0' }} >
                    <Col sm={6}>
                        <FormGroup>
                            <SeasonHeader seasonyears={seasonyears} />   
                        </FormGroup>
                        { (errors.length > 0) && <ErrorList errors={errors}/> }
                        <FormGroup>
                            <label className={lblattrs11}>Number of days before start date to allow download</label>
                            <Field
                                type='number'
                                name={`${season}.templateReleaseDays`}
                                component='input'
                                className="form-control no-spinners"
                                style={{ maxWidth: '70px' }}
                                max = {20} 
                                onChange={this.handleValueChange}   
                                parse={onlypositivenumbers}                                         
                            />
                        </FormGroup>
                        <FormGroup>
                            <Col lgOffset={ 2 } lg={ 10 }>
                                <button type="button"   className="btn btn-primary"  style={{ marginLeft:'20px' }} onClick={this.handleSaveTemplate} disabled={(datasaved == undefined) || (datasaved == true)  || errors.length > 0 || !isSeasonSet}>
                                    <i className={savingdata == true? 'fa fa-spinner fa-spin':"fa fa-cogs"} aria-hidden="true" /> &nbsp;&nbsp;Save Settings
                                </button>
                                {
                                    datasaved && (<InfoSaved section='Season template' />)
                                }
                            </Col>
                        </FormGroup>
                    </Col>
                </form>
            </Row>
        )
    }
}
function validate(values) {
    const { settingsseason,template } = values
    const errors = {}
 
    if(template && settingsseason){
        const season = template[settingsseason]
        const { templateReleaseDays,isSeasonSet } = season 
     
        let errorCounter = 0    
        
        if( isSeasonSet ){
        // check all values are provided
            if (!templateReleaseDays || templateReleaseDays <= 0) {
                errors[errorCounter++] = "Template release date must be a positive number"
            }
        }
        else {
            if( isSeasonSet != undefined  ) {
                errors[errorCounter++]  = "Initiate the season by clicking 'Setup season' in the Season Dates tab"
            }
        }
    }
    return errors
} 
Template.propTypes = {
    dispatch:PropTypes.func,
    initialize:PropTypes.func,
    syncErrors:PropTypes.object,
    settingsseason:PropTypes.number,
    savingdata:PropTypes.bool,
    datasaved:PropTypes.bool,
    seasonyears:PropTypes.string,
    template:PropTypes.object,
    saveSeasonTemplate:PropTypes.func,
    settingsSaved:PropTypes.func,
    resetTemplateSettings:PropTypes.func,
    resetform:PropTypes.bool,
    templatereset:PropTypes.bool,
    resetDone:PropTypes.func
}
function mapStateToProps(state,ownProps){
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const settingsseason = selector(state,'settingsseason')
    const template       = selector(state,'template')
    const savingdata     = selector(state,'savingdata')
    const datasaved      = selector(state,'datasaved')
    const templatereset  = selector(state,'templatereset')
    const syncErrors = getFormSyncErrors(formName)(state)
    return {     
        settingsseason,
        template,
        savingdata,
        templatereset,
        datasaved,
        syncErrors  
    }
}
function mapDispatchToProps(dispatch){
    return bindActionCreators({
        saveSeasonTemplate,
        resetTemplateSettings
    },dispatch)
}
export default reduxForm({
  validate,
  form:formName,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: false,
  initialValues:defaultformstate,
  enableReinitialize: true
})(connect(mapStateToProps,mapDispatchToProps)(Template))




// WEBPACK FOOTER //
// ./src/containers/season/Components/Template.js